import { useState, useCallback, useRef } from "react";
import { API } from '../../../api';

export default function PartnerPreview({ item, onDropImage, originalAvailable, showOriginal, onToggleOriginal }) {
	const [dragOver, setDragOver] = useState(false);
	const dragCounter = useRef(0);

	const handleDragOver = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		setDragOver(true);
	};

	const handleDragEnter = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current += 1;
		setDragOver(true);
	};

	const handleDragLeave = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current = Math.max(0, dragCounter.current - 1);
		if (dragCounter.current === 0) setDragOver(false);
	};

	const handleDrop = useCallback((e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current = 0;
		setDragOver(false);
		const file = e.dataTransfer?.files?.[0];
		if (!file) return;
		const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "image/avif"];
		if (!validTypes.includes(file.type)) return;

		// Laissez le gestionnaire parent créer l'Object URL et gérer le nettoyage
		onDropImage(file);
	}, [onDropImage]);

	if (!item) return (<div className="carrousel-preview empty"><p>Sélectionnez un partenaire pour voir l'aperçu</p></div>);

	const getImageSrc = () => {
		const typesource = (item.typesource || item.typesource || "").toLowerCase();
		const imgname = item.imgname || item.imgname || "";
		const ext = item.extension || "";
		const hasLoadError = item.urlLoadError === true;

		// Si URL web a échoué au chargement, ne pas retourner de src \\
		if (typesource === "web" && imgname && hasLoadError) return null;

		// Base64/Object URL preview (fichier local sélectionné) \\
		if (typesource === "preview" && imgname) return imgname;

		// URL web externe \\
		if (typesource === "web" && imgname && !hasLoadError) return imgname;

		// Fichier local stocké sur le serveur \\
		if (typesource === "local" && imgname && ext) return `${API.API_LINK}/file/pictures/partner/source/${imgname}.${ext}`;

		// Fallback: si pas de typesource mais qu'on a imgname et ext, on suppose local \\
		if (!typesource && imgname && ext) return `${API.API_LINK}/file/pictures/partner/source/${imgname}.${ext}`;

		return null;
	};

	const imageSrc = getImageSrc();
	const hasUrlError = item.urlLoadError === true;
	const isWebType = (item.typesource || "").toLowerCase() === "web";

	return (
		<div className={`admin-container-preview-t1${onDropImage ? " drop-enabled" : ""}${dragOver ? " drag-over" : ""}`}
			 onDragOver={handleDragOver}
			 onDragEnter={handleDragEnter}
			 onDragLeave={handleDragLeave}
			 onDrop={handleDrop}>
			<div className="preview-label">Aperçu en temps réel</div>
			<div className="top-preview-name">{item.enregistrementname}</div>
			<div className="container-preview-double">
				<div className="preview-Admin-T1">
					{imageSrc && !hasUrlError ? (
						<>
							{/* Rangée 1 - Gauche vers Droite */}
							<div className="preview-slider-row row-ltr">
								{[...Array(8)].map((_, i) => (
									<div 
										key={`row1-${i}`}
										className="preview-slider-item"
										style={{
											backgroundImage: `url(${imageSrc})`,
											animationDelay: `calc(20s / 8 * ${i} * -1)`
										}}
									/>
								))}
							</div>

							{/* Rangée 2 - Droite vers Gauche */}
							<div className="preview-slider-row row-rtl">
								{[...Array(8)].map((_, i) => (
									<div 
										key={`row2-${i}`}
										className="preview-slider-item"
										style={{
											backgroundImage: `url(${imageSrc})`,
											animationDelay: `calc(20s / 8 * ${i} * -1)`
										}}
									/>
								))}
							</div>

							{/* Rangée 3 - Gauche vers Droite */}
							<div className="preview-slider-row row-ltr">
								{[...Array(8)].map((_, i) => (
									<div 
										key={`row3-${i}`}
										className="preview-slider-item"
										style={{
											backgroundImage: `url(${imageSrc})`,
											animationDelay: `calc(20s / 8 * ${i} * -1)`
										}}
									/>
								))}
							</div>

							{/* Rangée 4 - Droite vers Gauche */}
							<div className="preview-slider-row row-rtl">
								{[...Array(8)].map((_, i) => (
									<div 
										key={`row4-${i}`}
										className="preview-slider-item"
										style={{
											backgroundImage: `url(${imageSrc})`,
											animationDelay: `calc(20s / 8 * ${i} * -1)`
										}}
									/>
								))}
							</div>
						</>
					) : (
						<div className="preview-placeholder">
							<span>📷</span>
							{hasUrlError && isWebType ? (
								<p style={{ color: '#e74c3c' }}>URL invalide</p>
							) : (
								<p>Aucune image sélectionnée</p>
							)}
						</div>
					)}
				</div>

				<div className="preview-unitaire-partner">
					<div 
						className="img-unitaire-partner bw" 
						style={{
							backgroundImage: `url(${imageSrc})`
						}}>
						<span>Preview noir & blanc</span>
					</div>
					<div 
						className="img-unitaire-partner" 
						style={{
							backgroundImage: `url(${imageSrc})`
						}}>
						<span>Preview couleur <br />(visible au survol de l'image)</span>
					</div>
				</div>
			</div>

			{/* <div 
										key={`row3-${i}`}
										className="preview-slider-item"
										style={{
											backgroundImage: `url(${imageSrc})`,
											animationDelay: `calc(20s / 8 * ${i} * -1)`
										}}
									/> */}
              

			{!item.isvisible && (
				<div className="preview-warning">⚠️ Ce partenaire est actuellement masqué</div>
			)}

			{originalAvailable && (
				<div className="preview-tools">
					<label className="toggle-switch">
						<input type="checkbox" checked={!!showOriginal} onChange={onToggleOriginal} />
						<span className="toggle-slider"></span>
						<span className="toggle-label">Voir la version originale</span>
					</label>
				</div>
			)}
		</div>
	);
}
